import { createContext } from "react";
import { IAnimeViewingInfo } from "../../models/anime-viewing-info";

export interface IViewingContext {
	info?: IAnimeViewingInfo;
}

export const ViewingContext = createContext<IViewingContext>({
});